'use strict';
import React from 'react';
import MediaFeatured from './mediaFeatured';
import flux from 'utils/flux';
import LoadingSpinner from 'components/spinner/spinner';

var MediaLandingPage = React.createClass({
    displayName: 'MediaLandingPage',
    mixins: [],
    propTypes: {},
    render() {
        if (flux.getStore('modals').getState().loading) {
            return (<LoadingSpinner/>);
        }
        return <MediaFeatured landingPage={this.props.mediaStore.landingPage} />;
    }
});

module.exports = MediaLandingPage;



// WEBPACK FOOTER //
// ./app/pages/media/mediaLandingPage.jsx